import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import React, { useEffect, useState } from "react";

interface Props {
  Component: any;
}

const ContactRequest: React.FC<Props> = ({ Component }) => {
  const [data, setData] = useState<any>([]);
  const [showData, setShowData] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);

  useEffect(() => {
    Axios(AxiosMethodEnum.get, Axios_Route.CONTACT_AGENT_REQUEST, {
      pageNumber: pageNumber,
      pageSize: 20,
      isContactUs: true,
    }).then(({ response, success }) => {
      if (success) {
        setData(response);
        setShowData(true);
      }
    });
  }, [pageNumber]);

  const changeData = () => {
    Axios(AxiosMethodEnum.get, Axios_Route.CONTACT_AGENT_REQUEST, {
      pageNumber: pageNumber,
      pageSize: 20,
      isContactUs: true,
    }).then(({ response, success }) => {
      if (success) {
        setData(response);
      }
    });
  };

  return (
    <div>
      <Component
        data={data}
        showData={showData}
        setPageNumber={setPageNumber}
        changeData={changeData}
      />
    </div>
  );
};

export default ContactRequest;
